import $ from 'jquery';

$(_ => {

  const $form = $('#fixed-package');
  if ($form.length === 0) return;

  const $group = $('#fixed-package--select--group');
  const $packages = $('#fixed-package--select--package');
  const $preview = $('#fixed-package--preview-container');
  const $packageSelects = $('.js-fixed-package--select--package-group');
  const $previews = $('.js-fixed-package--preview');

  let isVisible = false;

  $group.on('change', _ => {
    const groupId = $group.val();
    if (groupId) {
      const optionsHtml = $packageSelects.filter(`[data-pkg-group-id="${groupId}"]`).html();
      $packages.html(optionsHtml).prop('disabled', false);
    } else {
      $packages.html('').prop('disabled', true);
    }
    update();
  });

  $packages.on('change', _ => {
    const packageId = $packages.val();
    $previews.hide();
    if (packageId) {
      $previews.filter(`[data-pkg-id="${packageId}"]`).show();
    }
    update();
  });

  function update() {
    let visible = $group.val() && $packages.val();

    if (visible !== isVisible) {

      if (visible) {
        $preview.slideDown();
      } else {
        $preview.slideUp();
      }

      isVisible = visible;
    }
  }

});